<div class="activities-management-page">
  @if (deleteSuccessMessage) {
  <div class="management-toast management-toast--delete" role="status">
    <i class="pi pi-check"></i>
    <span>{{ deleteSuccessMessage }}</span>
    <button type="button" class="management-toast-close" (click)="dismissDeleteSuccess()">
      <i class="pi pi-times"></i>
    </button>
  </div>
  }
  @if (operationErrorMessage) {
  <div class="management-toast management-toast--error" role="alert">
    <i class="pi pi-exclamation-circle"></i>
    <span>{{ operationErrorMessage }}</span>
    <button type="button" class="management-toast-close" (click)="onOperationErrorChange('')">
      <i class="pi pi-times"></i>
    </button>
  </div>
  }

  <div class="activities-management-content">
    <div class="mb-4">
      <h2 class="management-page-title">{{ 'activitiesManagement.title' | translate }}</h2>
      <p class="management-page-subtitle">{{ 'activitiesManagement.subtitle' | translate }}</p>
    </div>

    <div class="summary-cards mb-4 w-full grid gap-4 grid-cols-1 sm:grid-cols-2 xl:grid-cols-5">
      <bo-summary-card [title]="'activityStatus.total' | translate" iconBackground="#0a4a60" titleClass="text-[14px] font-semibold text-[color:var(--text-color)] tracking-normal">
        <span summaryCardIcon>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="5" cy="5" r="2.5" fill="none"></circle>
            <circle cx="19" cy="5" r="2.5" fill="none"></circle>
            <circle cx="5" cy="19" r="2.5" fill="none"></circle>
            <circle cx="19" cy="19" r="2.5" fill="none"></circle>
            <line x1="7.5" y1="5" x2="16.5" y2="5"></line>
            <line x1="7.5" y1="19" x2="16.5" y2="19"></line>
            <line x1="5" y1="7.5" x2="5" y2="16.5"></line>
            <line x1="19" y1="7.5" x2="19" y2="16.5"></line>
          </svg>
        </span>
        <span summaryCardValue>
          @if (summaryLoading) {
          <span class="summary-loading-line summary-loading-line--value"></span>
          } @else {
          {{ activitySummary.totalActivities | number }}
          }
        </span>
        <span summaryCardDescription [ngClass]="growthClass(activitySummary.createdGrowthPct)">
          @if (summaryLoading) {
          <span class="summary-loading-line summary-loading-line--description"></span>
          } @else {
          +{{ activitySummary.activitiesCreatedThisMonth | number }} {{ 'activitiesManagement.thisMonth' | translate }}<ng-container *ngIf="activitySummary.createdGrowthPct !== null"> · {{ activitySummary.createdGrowthPct >= 0 ? '+' : '' }}{{ activitySummary.createdGrowthPct }}% {{ 'activitiesManagement.fullMonths' | translate }}</ng-container>
          }
        </span>
      </bo-summary-card>

      <bo-summary-card [title]="'activitiesManagement.partnerSeats' | translate" iconBackground="#fca13b" titleClass="text-[14px] font-semibold text-[color:var(--text-color)] tracking-normal">
        <span summaryCardIcon>
          <img src="assets/layout/images/logo-bg-white.svg" class="summary-card-logo filter brightness-0 invert"
            alt="" />
        </span>
        <span summaryCardValue>
          @if (summaryLoading) {
          <span class="summary-loading-line summary-loading-line--value"></span>
          } @else {
          {{ activitySummary.partnerSeats | number }}
          }
        </span>
        <span summaryCardDescription [ngClass]="growthClass(activitySummary.partnerSeatsGrowthPct)">
          @if (summaryLoading) {
          <span class="summary-loading-line summary-loading-line--description"></span>
          } @else {
          <ng-container *ngIf="activitySummary.partnerSeatsGrowthPct !== null">{{ activitySummary.partnerSeatsGrowthPct >= 0 ? '+' : '' }}{{ activitySummary.partnerSeatsGrowthPct }}% {{ 'activitiesManagement.fullMonths' | translate }} · </ng-container>{{ activitySummary.totalParticipants | number }} {{ 'activitiesManagement.uniqueParticipants' | translate }}
          }
        </span>
      </bo-summary-card>

      <bo-summary-card [title]="'activityStatus.incoming' | translate" iconBackground="#479e9c" titleClass="text-[14px] font-semibold text-[color:var(--text-color)] tracking-normal">
        <span summaryCardIcon>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M6.5 3.25v4.5M14.5 3.25v4.5"></path>
            <path d="M4.25 6.25h12.5c1.1 0 2 .9 2 2v8.5c0 1.1-.9 2-2 2H6.25c-1.1 0-2-.9-2-2v-8.5c0-1.1.9-2 2-2Z"></path>
            <path d="M4.25 10.25h14.5"></path>
            <circle cx="17.5" cy="17.25" r="4.25" fill="#479e9c"></circle>
            <path d="M17.5 15.25v2.25l1.65 1"></path>
          </svg>
        </span>
        <span summaryCardValue>
          @if (summaryLoading) {
          <span class="summary-loading-line summary-loading-line--value"></span>
          } @else {
          {{ activitySummary.incoming | number }}
          }
        </span>
        <span summaryCardDescription>
          @if (summaryLoading) {
          <span class="summary-loading-line summary-loading-line--description"></span>
          } @else {
          {{ 'activitiesManagement.upcomingDesc' | translate }}
          }
        </span>
      </bo-summary-card>

      <bo-summary-card [title]="'activityStatus.completionRate' | translate" iconBackground="#1f8554" titleClass="text-[14px] font-semibold text-[color:var(--text-color)] tracking-normal">
        <span summaryCardIcon>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 19V5"></path>
            <path d="M5 19h14"></path>
            <path d="M8 15.5l3-4 3 2.8L18 8"></path>
          </svg>
        </span>
        <span summaryCardValue>
          @if (summaryLoading) {
          <span class="summary-loading-line summary-loading-line--value"></span>
          } @else {
          {{ activitySummary.completionRate }}%
          }
        </span>
        <span summaryCardDescription [ngClass]="growthClass(activitySummary.completionDelta)">
          @if (summaryLoading) {
          <span class="summary-loading-line summary-loading-line--description"></span>
          } @else {
          {{ activitySummary.completionDelta >= 0 ? '+' : '' }}{{ activitySummary.completionDelta }} pts {{ 'activitiesManagement.vsLastMonth' | translate }}
          }
        </span>
      </bo-summary-card>

      <bo-summary-card [title]="'activitiesManagement.withoutPartnersTitle' | translate" iconBackground="#c0392b"
        titleClass="text-[14px] font-semibold text-[color:var(--text-color)] tracking-normal" class="kpi-alert-card">
        <span summaryCardIcon>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="8" r="3.5"></circle>
            <path d="M5.5 20c.8-3.2 3.4-5 6.5-5s5.7 1.8 6.5 5"></path>
            <path d="M19 4l3 3M22 4l-3 3"></path>
          </svg>
        </span>
        <span summaryCardValue class="kpi-alert-value">
          @if (summaryLoading) {
          <span class="summary-loading-line summary-loading-line--value"></span>
          } @else {
          {{ activitySummary.upcomingWithoutPartners | number }}
          }
        </span>
        <span summaryCardDescription>
          @if (summaryLoading) {
          <span class="summary-loading-line summary-loading-line--description"></span>
          } @else {
          <button type="button" class="kpi-alert-link" (click)="focusWithoutPartners()">{{ 'activitiesManagement.seeThem' | translate }}</button>
          }
        </span>
      </bo-summary-card>
    </div>

    <div class="management-panel w-full rounded-md p-4">
      <div class="flex flex-col gap-3 mb-4">
        <div class="flex flex-wrap gap-4 items-center">
          <button type="button" (click)="toggleFilter()"
            class="filters-toggle-btn flex items-center gap-2 px-3 py-2 border border-[color:var(--surface-border)] rounded-md text-sm text-[color:var(--text-color)]">
            <i class="pi pi-filter"></i>
            {{ 'activitiesManagement.filters' | translate }}
            <i class="pi text-[10px]" [ngClass]="showFilter ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
          </button>

          <div class="p-inputgroup w-96 search-bar">
            <span class="p-inputgroup-addon bg-[color:var(--surface-card)] border-[color:var(--surface-border)] text-[color:var(--text-color)] border-r-0"><i
                class="pi pi-search"></i></span>
            <input pInputText [placeholder]="'activitiesManagement.searchPlaceholder' | translate" [(ngModel)]="searchQuery"
              (ngModelChange)="onSearchChanged()"
              class="bg-[color:var(--surface-card)] border-[color:var(--surface-border)] text-[color:var(--text-color)] border-l-0 focus:shadow-none" />
          </div>
        </div>

        <div class="quick-chips">
          <button type="button" class="quick-chip" [class.quick-chip--on]="quickUpcoming" (click)="toggleQuickUpcoming()">{{ 'activitiesManagement.chipUpcoming' | translate }}</button>
          <button type="button" class="quick-chip" [class.quick-chip--on]="quickThisWeek" (click)="toggleQuickThisWeek()">{{ 'activitiesManagement.chipThisWeek' | translate }}</button>
          <button type="button" class="quick-chip quick-chip--alert" [class.quick-chip--on]="quickWithoutPartners" (click)="toggleQuickWithoutPartners()">{{ 'activitiesManagement.chipWithoutPartners' | translate }}</button>
          <button type="button" class="quick-chip" [class.quick-chip--on]="quickFull" (click)="toggleQuickFull()">{{ 'activitiesManagement.chipFull' | translate }}</button>
          <button type="button" class="quick-chip" [class.quick-chip--on]="quickWeekly" (click)="toggleQuickWeekly()">{{ 'activitiesManagement.chipWeekly' | translate }}</button>
        </div>

        <div class="filter-row" *ngIf="showFilter">
          <label class="filter-field">
            <span>{{ 'activitiesManagement.dateRange' | translate }}</span>
            <div #dateRangeField class="date-range-field">
              <p-calendar #dateRangeCalendar [(ngModel)]="dateRangeSelection" (onSelect)="onDateRangeSelected()"
                (onShow)="onDateRangeCalendarShow()" (onMonthChange)="onDateRangeCalendarNavigate()"
                (onYearChange)="onDateRangeCalendarNavigate()" selectionMode="range" [appendTo]="'body'"
                [numberOfMonths]="1" [showOtherMonths]="false" [readonlyInput]="true" [showOnFocus]="false"
                [autoZIndex]="true" [baseZIndex]="1300" dateFormat="dd/mm/yy" styleClass="activity-date-calendar-anchor"
                inputStyleClass="activity-date-calendar-input" panelStyleClass="activity-date-calendar-popover"
                [panelStyle]="dateRangeCalendarPanelStyle" />

              <button type="button" class="date-range" (mousedown)="toggleDateRangeCalendar($event)"
                (click)="$event.preventDefault(); $event.stopPropagation()">
                <span class="date-range-value" [class.date-range-value--selected]="hasDateRangeStart()">
                  {{ getDateRangeStartLabel() }}
                </span>
                <span class="date-range-arrow" aria-hidden="true">
                  <svg viewBox="0 0 14 8" focusable="false">
                    <path d="M1 4H12M9 1L12 4L9 7" />
                  </svg>
                </span>
                <span class="date-range-value" [class.date-range-value--selected]="hasDateRangeEnd()">
                  {{ getDateRangeEndLabel() }}
                </span>
              </button>

              <button type="button" class="date-range-calendar" aria-label="Open date range picker"
                (mousedown)="toggleDateRangeCalendar($event)"
                (click)="$event.preventDefault(); $event.stopPropagation()">
                <i class="pi pi-calendar"></i>
              </button>
            </div>
          </label>

          <label class="filter-field">
            <span>{{ 'activitiesManagement.statusLabel' | translate }}</span>
            <div class="custom-dropdown">
              <p-dropdown [options]="statusOptions" [(ngModel)]="selectedStatus" (ngModelChange)="onFilterChanged()"
                optionLabel="label" optionValue="value" styleClass="w-[238px]"
                panelStyleClass="groups-sport-dropdown-panel"></p-dropdown>
            </div>
          </label>

          <label class="filter-field">
            <span>{{ 'activitiesManagement.sportLabel' | translate }}</span>
            <div class="custom-dropdown">
              <p-dropdown [options]="sportFilterOptions" [(ngModel)]="selectedSportId"
                (ngModelChange)="onFilterChanged()" optionLabel="label" optionValue="value"
                styleClass="w-[238px]" panelStyleClass="groups-sport-dropdown-panel"></p-dropdown>
            </div>
          </label>

          <label class="filter-field">
            <!-- Address rather than city: the stored value is a full formatted
                 address, so the field is named for what it actually matches. -->
            <span>{{ 'activitiesManagement.addressContains' | translate }}</span>
            <input type="text" pInputText class="w-[238px]" [placeholder]="'activitiesManagement.addressPlaceholder' | translate"
              [(ngModel)]="locationQuery" (keyup.enter)="onFilterChanged()" (blur)="onFilterChanged()" />
          </label>

          <button pButton type="button" [icon]="exportingCsv ? 'pi pi-spin pi-spinner' : 'pi pi-download'"
            [label]="(exportingCsv ? 'activitiesManagement.exporting' : 'activitiesManagement.exportCsv') | translate" [disabled]="exportingCsv"
            class="custom-clear-btn p-button-sm font-normal border-none text-white rounded-md px-4"
            (click)="exportCsv()"></button>

          <button pButton type="button" icon="pi pi-times" [label]="'activitiesManagement.clearFilter' | translate"
            class="custom-clear-btn p-button-sm font-normal border-none text-white rounded-md px-4"
            (click)="clearFilter()"></button>
        </div>
      </div>

      <div class="custom-table">
        <p-table #activitiesTable [value]="activities" [paginator]="true" [lazy]="true" [first]="tableFirst" [rows]="tableRows"
          [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 25, 50]" [showCurrentPageReport]="true"
          [sortField]="tableSortField"
          [sortOrder]="tableSortOrderValue"
          [loading]="tableLoading" [currentPageReportTemplate]="'activitiesManagement.pageReport' | translate"
          (onLazyLoad)="onTableLazyLoad($event)" styleClass="p-datatable-sm">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="name">
                <div class="table-head-label">
                  <span>{{ 'activitiesManagement.colActivity' | translate }}</span>
                  <p-sortIcon field="name"></p-sortIcon>
                </div>
              </th>
              <th pSortableColumn="group">
                <div class="table-head-label">
                  <span>{{ 'activitiesManagement.colGroup' | translate }}</span>
                  <p-sortIcon field="group"></p-sortIcon>
                </div>
              </th>
              <th pSortableColumn="date">
                <div class="table-head-label">
                  <span>{{ 'activitiesManagement.colDate' | translate }}</span>
                  <p-sortIcon field="date"></p-sortIcon>
                </div>
              </th>
              <th pSortableColumn="status">
                <div class="table-head-label">
                  <span>{{ 'activitiesManagement.colStatus' | translate }}</span>
                  <p-sortIcon field="status"></p-sortIcon>
                </div>
              </th>
              <th pSortableColumn="participants">
                <div class="table-head-label table-head-label--center">
                  <span>{{ 'activitiesManagement.colFill' | translate }}</span>
                  <p-sortIcon field="participants"></p-sortIcon>
                </div>
              </th>
              <th>
                <div class="table-head-label table-head-label--center">
                  <span>{{ 'activitiesManagement.colActions' | translate }}</span>
                </div>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-activity>
            <tr
              class="cursor-pointer"
              (pointerdown)="preventRowTextActivation($event)"
              (click)="openActivityFromList(activity)"
            >
              <td
                class="activity-name-column"
              >
                <div class="activity-cell">
                  <ng-container *ngIf="hasActivityThumbnailUrl(activity); else activityThumbPlaceholder">
                    <img [src]="activity.thumbnailUrl" alt="" class="activity-thumb"
                      (error)="onListThumbError(activity)" />
                  </ng-container>
                  <ng-template #activityThumbPlaceholder>
                    <div class="activity-thumb activity-thumb-placeholder" aria-hidden="true">
                      <img [src]="getSportIconPath(activity.sportIcon || activity.sport)"
                        class="activity-thumb-placeholder-icon" alt="" />
                    </div>
                  </ng-template>
                  <div class="activity-copy min-w-0">
                    <span
                      class="activity-name table-text-cell"
                      [pTooltip]="activity.name"
                      tooltipPosition="top"
                      tooltipStyleClass="activities-name-tooltip"
                    >{{ activity.name }}</span>
                    <span
                      class="activity-host table-text-cell"
                    >{{ 'activitiesManagement.by' | translate }} {{ activity.host }}</span>
                  </div>
                </div>
              </td>
              <td class="text-[color:var(--text-color)] text-[14px] font-normal text-left">
                <span
                  class="table-text-cell"
                  [pTooltip]="getActivityGroup(activity) !== '--' ? getActivityGroup(activity) : undefined"
                  tooltipPosition="top"
                >{{ getActivityGroup(activity) }}</span>
              </td>
              <td>
                <div class="date-cell">
                  <div class="date-cell-primary">
                    <span class="date-cell-time">
                      {{ getActivityDate(activity) | date: 'EEE' }}
                      <span class="date-cell-dot">&middot;</span>
                      {{ getActivityDate(activity) | date: 'HH:mm' }}
                    </span>
                    <span *ngIf="isWeeklyActivity(activity)" class="date-frequency-pill">{{ 'activitiesManagement.weekly' | translate }}</span>
                  </div>
                  <small class="date-cell-range">
                    <ng-container *ngIf="isWeeklyActivity(activity); else singleActivityDate">
                      {{ getActivityDate(activity) | date: 'dd/MM/yyyy' }} &ndash; {{ getActivityRangeEndDate(activity)
                      | date: 'dd/MM/yyyy' }}
                    </ng-container>
                    <ng-template #singleActivityDate>{{ getActivityDate(activity) | date: 'dd/MM/yyyy' }}</ng-template>
                  </small>
                </div>
              </td>
              <td>
                <span class="status-pill" [ngClass]="'status-pill--' + getActivityStatus(activity)">
                  {{ 'activityStatus.' + getActivityStatus(activity) | translate }}
                </span>
              </td>
              <td>
                <div class="fill-cell" [class.fill-cell--zero]="activity.participants === 0 && partnerCapacity(activity) !== null">
                  <span class="fill-cell-nums">{{ activity.participants }}<ng-container *ngIf="partnerCapacity(activity) !== null"><small>/{{ partnerCapacity(activity) }}</small></ng-container></span>
                  <div class="fill-cell-gauge" *ngIf="partnerCapacity(activity) !== null">
                    <div class="fill-cell-bar"
                      [class.fill-cell-bar--full]="fillPercent(activity) >= 100"
                      [class.fill-cell-bar--zero]="activity.participants === 0"
                      [style.width.%]="activity.participants === 0 ? 6 : fillPercent(activity)"></div>
                  </div>
                </div>
              </td>
              <td>
                <div class="table-actions">
                  <button
                    type="button"
                    class="table-action-btn table-action-btn--edit"
                    [pTooltip]="'activitiesManagement.editTooltip' | translate"
                    tooltipPosition="left"
                    appendTo="body"
                    (click)="openEditActivityMode(activity); $event.stopPropagation()"
                  >
                    <svg class="table-edit-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                      <path class="table-edit-icon-pencil-head"
                        d="M17.25 3.75L20.25 6.75L21.35 5.65C21.95 5.05 21.95 4.05 21.35 3.45L20.55 2.65C19.95 2.05 18.95 2.05 18.35 2.65L17.25 3.75Z">
                      </path>
                    </svg>
                  </button>
                  <button
                    type="button"
                    class="table-action-btn table-action-btn--danger"
                    [pTooltip]="getActivityActionTooltip(activity)"
                    tooltipPosition="left"
                    appendTo="body"
                    (click)="openDeleteActivityMode(activity); $event.stopPropagation()"
                  >
                    @if (isActivityIncoming(activity)) {
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
                      <rect x="3" y="3" width="18" height="18" rx="2"></rect>
                      <path d="M16 8l-8 8M8 8l8 8"></path>
                    </svg>
                    } @else {
                    <i class="pi pi-trash"></i>
                    }
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr class="activities-empty-row">
              <td colspan="6">
                <div class="activities-empty-state">{{ 'activitiesManagement.empty' | translate }}</div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <p class="fill-rule-note">{{ 'activitiesManagement.fillNote' | translate }}</p>
    </div>
  </div>

  <bo-activity-drawer-host #activityDrawerHost [manageDeleteDialog]="true" [sportTypeConfigs]="sportTypeConfigs"
    [dismissibleOnMaskClick]="true"
    [sportOptions]="editGroupSportOptions" [defaultCoverPhotoUrl]="defaultCoverPhotoUrl"
    [externalOperationError]="operationErrorMessage"
    (externalOperationErrorChange)="onOperationErrorChange($event)"
    (activitySaved)="onActivitySaved($event)" (activityDeleted)="onActivityDeleted($event)"
    (activityCancelled)="onActivityCancelled($event)"
    (sessionChange)="onActivitySessionChange()" (visibilityChange)="onActivityVisibilityChange($event)" />

  <bo-cancel-activity-dialog
    [visible]="cancelDialogVisible"
    [closing]="cancelDialogClosing"
    [restoreWithoutTransition]="skipCancelDialogEnterAnimation"
    [confirmed]="cancelConfirmed"
    [activityName]="activityToCancel?.name ?? ''"
    (closed)="closeCancelDialog()"
    (hidden)="onCancelDialogHidden()"
    (confirmedChange)="onCancelConfirmedChange($event)"
    (canceled)="onCancelConfirmed()"
  />

  <bo-cancel-paid-activity-dialog
    [visible]="cancelPaidDialogVisible"
    [closing]="cancelPaidDialogClosing"
    [restoreWithoutTransition]="skipCancelPaidDialogEnterAnimation"
    [confirmed]="cancelPaidConfirmed"
    [activityName]="activityToCancel?.name ?? ''"
    (closed)="closeCancelPaidDialog()"
    (hidden)="onCancelPaidDialogHidden()"
    (confirmedChange)="onCancelPaidConfirmedChange($event)"
    (canceled)="onCancelPaidConfirmed()"
  />
</div>
